export default function isDate(value: string): boolean {
  // @ts-ignore
  return new Date(value) !== 'Invalid Date' && !isNaN(new Date(value));
}
